module.exports = __webpack_public_path__ + "img/inu_gallery9.7bdb5919.jpg";